export default __webpack_public_path__ + "static/media/optique2.372734d6.jpg";